<template>
  <iframe
    title="Inline Frame Example"
    width="1000"
    height="530"
    :src="detailData.url"></iframe>
  <!-- <a :href="detailData" target="_blank">{{ detailData.substring(8) }}</a> -->
</template>

<script>
export default {
  name: 'vendorCode101',
  props: ['detailData']
}
</script>

<style scoped></style>
<script setup></script>
